import { render, staticRenderFns } from "./ModalReview.vue?vue&type=template&id=20d08166&"
import script from "./ModalReview.vue?vue&type=script&lang=js&"
export * from "./ModalReview.vue?vue&type=script&lang=js&"
import style0 from "./ModalReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports